import type { CookieOptions } from './types';

import { buildCookieString, escapeRegExp, normalizeSetOptions } from './utils';

// ----------------------------------------------------------------------------

function get(name: string): string | null {
    const match = new RegExp(`(?:^|; )${escapeRegExp(encodeURIComponent(name))}=([^;]*)`).exec(document.cookie);

    if (!match) {
        return null;
    }

    try {
        return decodeURIComponent(match[1]);
    } catch {
        return null;
    }
}

function set(name: string, value: string, daysOrOptions: number | CookieOptions = 3): void {
    document.cookie = buildCookieString(name, value, normalizeSetOptions(daysOrOptions));
}

function remove(name: string, options: Omit<CookieOptions, 'days' | 'maxAge'> = {}): void {
    set(name, '', {
        ...options,
        days: -1,
    });
}

// ----------------------------------------------------------------------------

export { get, set, remove };
